
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/cpd-professional/[course]",
      function () {
        return require("private-next-pages/courses/cpd-professional/[course].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/cpd-professional/[course]"])
      });
    }
  